var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#171D29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L43 13L28 28L13 13Z",
    fill: "#E33B48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43L13 43L28 28L43 43Z",
    fill: "#4A74E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWx);
export default __webpack_public_path__ + "static/media/WX.55605316dcb34609db3828ccbc329473.svg";
export { ForwardRef as ReactComponent };